export const UnderlineAnimation = () => (
  <span className='bg-brand absolute bottom-0 left-0 -mb-0.5 block h-0.5 w-full max-w-0 transition-all duration-200 group-hover:max-w-full' />
);
